function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".like-1{fill:#fff;}.filled .like-1{fill:#bfdfef;}.like-2,.like-3{fill:none;stroke:#97aeb7;stroke-width:3px;}.like-2{stroke-linejoin:round;}.like-3{stroke-miterlimit:10;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "like");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "like-1",
  d: "M16.21,5.28S13.5,16,7.5,19.64v17a62.59,62.59,0,0,1,9.23-.75c2,0,3.93,2.83,10,2.83,2.88,0,5.15.7,6.45-1.15s0-2.68.18-2.8c3.25-1.9,2.59-2.76,2.65-4,.08-1.68-2-2.24-2-2.24a3.18,3.18,0,0,0,2.3-2.88c.19-1.94.06-4.06-2.19-4.06-.5,0,.81-1,1.21-2a2.29,2.29,0,0,0-2.55-3.15c-2.25.15-12.21,1.8-12.81.9s4.47-8.22,1.8-13.31c-2.1-4-5.1-3.15-5.5,1.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "like-2",
  d: "M16.21,5.28S13.5,16,7.5,19.64v17a62.59,62.59,0,0,1,9.23-.75c2,0,3.93,2.83,10,2.83,2.88,0,5.15.7,6.45-1.15s0-2.68.18-2.8c3.25-1.9,2.59-2.76,2.65-4,.08-1.68-2-2.24-2-2.24a3.18,3.18,0,0,0,2.3-2.88c.19-1.94.06-4.06-2.19-4.06-.5,0,.81-1,1.21-2a2.29,2.29,0,0,0-2.55-3.15c-2.25.15-12.21,1.8-12.81.9s4.47-8.22,1.8-13.31C19.61.08,16.61.93,16.21,5.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "like-1",
  d: "M3.5,36a1,1,0,0,1-2,0V21a1,1,0,0,1,2,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "like-3",
  d: "M3.5,36a1,1,0,0,1-2,0V21a1,1,0,0,1,2,0Z"
})));

var SvgLike = function SvgLike(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37.81 40.38",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/like.fa1d771a.svg";
export { ForwardRef as ReactComponent };